import { FC } from 'react';

import { ColumnTable } from '@/components/ColumnTable';
import { DetailsSection } from '@/components/SectionWithCard';
import { SavedQueryResult } from '@/hooks/dbtStrategy/useSavedQuery';

type SavedQuery = Omit<SavedQueryResult, 'applied'> | null;

interface QueryExportsViewProps {
  resource: SavedQuery | null;
}

const useQueryExports = (resource: SavedQuery) => {
  if (resource?.definition == null) return null;
  if (resource.definition.__typename !== 'SavedQueryDefinitionNode') return [];
  const queryExports = resource.definition.exports;
  return queryExports?.map((queryExport) => ({
    name: queryExport?.name ?? null,
    config: queryExport?.config ?? null,
  }));
};

export const QueryExportsView: FC<QueryExportsViewProps> = ({ resource }) => {
  const queryExports = useQueryExports(resource);

  if (queryExports == null) {
    return <div className="mt-10 text-fgDecorative">Loading...</div>;
  }

  if (!queryExports.length) {
    return <div className="mt-10 text-fgDecorative">No query exports found.</div>;
  }
  return (
    <ul aria-label="queryExports" className="mt-10 space-y-2">
      {queryExports.map((queryExport, index) => {
        const c = queryExport.config;
        return (
          <DetailsSection
            heading={queryExport.name || undefined}
            key={queryExport?.name ?? `${index}`}
          >
            <ColumnTable
              key={queryExport?.name ?? `${index}`}
              isLoading={false}
              tableEntries={[
                { key: 'Alias', data: c?.alias },
                { key: 'Export As', data: c?.exportAs },
                { key: 'Schema', data: c?.schema },
                { key: 'Database', data: c?.database },
              ]}
            />
          </DetailsSection>
        );
      })}
    </ul>
  );
};
